<p-dialog header="User Details" [(visible)]="display" [modal]="true" [style]="{width: '80%'}" appendTo="body"
    (onHide)="onClose()">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-10">
                <h5>{{selectedUser?.name}}</h5>
                <div class="p-grid">
                    <div class="p-col-2">
                        Role:
                    </div>
                    <div class="p-col-10">
                        <strong>{{selectedUser?.role?.role?.name}}</strong>
                    </div>
                </div>
                <div class="p-grid">
                    <div class="p-col-2">
                        Work Email:
                    </div>
                    <div class="p-col-10">
                        <strong>{{selectedUser?.emailId}}</strong>
                    </div>
                </div>
                <ng-container *ngIf="selectedUser?.userPhones?.length">
                    <div class="p-grid" *ngFor="let phone of selectedUser?.userPhones">
                        <div class="p-col-2">
                            {{ phone?.phone?.phoneType?.name }} Phone:
                        </div>
                        <div class="p-col-10">
                            <strong>{{ phone?.phone?.number }}</strong>
                        </div>
                    </div>
                </ng-container>
    
            </div>
            <div class="p-col-2">
                <div class="profilePic p-d-flex p-ai-center p-jc-center" *ngIf="selectedUser?.profileImage?.location">
                    <img [src]="selectedUser?.profileImage?.location" alt="Profile" 
                         class="p-image" 
                         style="max-height: 300px; object-fit: fill; width: 100%;" />
                </div>                
                <!-- <div class="p-text-center p-mt-3">Last Logged In:
                    <span style="font-weight: bold;">12/23/2024 08:50 PM</span>
                </div> -->
            </div>
        </div>
        <p-tabView [(activeIndex)]="index">
            <p-tabPanel header="Details">
                <div class="p-grid">
                    <div class="p-col-2">
                        Gender:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.gender}}</strong>
                    </div>
                    <div class="p-col-2">
                        Job Type:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.department}}</strong>
                    </div>
                    <div class="p-col-2">
                        Department:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.role?.organizationDepartment?.department?.name}}</strong>
                    </div>
                    <div class="p-col-2">
                        DOB:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.dateOfBirth |localDate:'MM/DD/YYYY':false}}</strong>
                    </div>
                    <div class="p-col-2">
                        Language Spoken:
                    </div>
                    <div class="p-col-4">
                        <ng-container *ngFor="let item of selectedUser?.userLanguages">
                            <span> <strong>{{item?.language?.name}}</strong></span>
                        </ng-container>
                    </div>
                    <div class="p-col-2">
                        Start Date:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.userDetail?.joiningDate |localDate:'MM/DD/YYYY':false }} </strong>
                    </div>
                    <div class="p-col-2">
                        Marital Status:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.userDetail?.maritalStatus?.name}}</strong>
                    </div>
                    <div class="p-col-2">
                        Degree:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.userDetail?.degree?.name}}</strong>
                    </div>
                    <div class="p-col-2">
                        Annual Income:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.userDetail?.annualIncome?.name}}</strong>
                    </div>
                    <div class="p-col-2">
                        Field of Study:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.userDetail?.fieldOfStudy?.name}}</strong>
                    </div>
                    <div class="p-col-2">
                        Seniority:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.seniority}}</strong>
                    </div>
                    <div class="p-col-2">
                        Working Location:
                    </div>
                    <div class="p-col-4">
                        <strong>{{selectedUser?.locations[0]?.name}}<span *ngIf="selectedUser?.locations[0]?.locationType?.name">-</span>{{selectedUser?.locations[0]?.locationType?.name}}</strong>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Address">
                <div>
                    <div class="p-grid">
                        <div class="p-col-12">
                            <b>Home Address</b>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Street 1:
                        </div>
                        <div class="p-col-10">
                            <strong>{{selectedUser?.mainAddress?.streetAddress1}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Street 2:
                        </div>
                        <div class="p-col-10">
                            <strong>{{selectedUser?.mainAddress?.streetAddress2}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            City:
                        </div>
                        <div class="p-col-10">
                            <strong>{{selectedUser?.mainAddress?.city?.name}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            State:
                        </div>
                        <div class="p-col-10">
                            <strong>{{selectedUser?.mainAddress?.state?.name}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Country:
                        </div>
                        <div class="p-col-10">
                            <strong>{{selectedUser?.mainAddress?.country?.name}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Zipcode:
                        </div>
                        <div class="p-col-10">
                            <strong>{{selectedUser?.mainAddress?.zipCode}}</strong>
                        </div>
                    </div>
                </div>
                <div *ngFor="let a of selectedUser?.locations" class="p-mb-3">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <b>Office Address</b>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Street 1:
                        </div>
                        <div class="p-col-10">
                            <strong>{{a?.address?.streetAddress1}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Street 2:
                        </div>
                        <div class="p-col-10">
                            <strong>{{a?.address?.streetAddress2}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            City:
                        </div>
                        <div class="p-col-10">
                            <strong>{{a?.address?.city?.name}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            State:
                        </div>
                        <div class="p-col-10">
                            <strong>{{a?.address?.state?.name}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Country:
                        </div>
                        <div class="p-col-10">
                            <strong>{{a?.address?.country?.name}}</strong>
                        </div>
                    </div>
                    <div class="p-grid">
                        <div class="p-col-2">
                            Zipcode:
                        </div>
                        <div class="p-col-10">
                            <strong>{{a?.address?.zipCode}}</strong>
                        </div>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="Social">
                <ng-container *ngIf="selectedUser?.userSocialProfiles?.length">
                    <div class="p-grid" *ngFor="let profile of selectedUser?.userSocialProfiles">
                        <div class="p-col-2">
                            {{ profile?.socialProfile?.socialProfileType?.name}}:
                        </div>
                        <div class="p-col-10">
                            <strong><a [href]="profile?.socialProfile?.name"
                                target="_blank">{{profile?.socialProfile?.name}}</a></strong>
                        </div>
                    </div>
                </ng-container>
            </p-tabPanel>
            <!-- <p-tabPanel header="Communication Preference">
                <p-table [value]="communication" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr>
                            <th></th>
                            <th>Subscription</th>
                            <th>Unsubscription</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>{{product.name}}</td>
                            <td [class.action]="product.name !== 'SMS' && product.name !== 'WhatsApp'">
                                <ng-container *ngIf="product.name === 'SMS' || product.name === 'WhatsApp'">
                                    <span class="pi pi-check" style="color: #7be959;" *ngIf="product.isSubscrib"></span>
                                    <span class="pi pi-times" *ngIf="!product.isSubscrib"></span>
                                </ng-container>
                                <ng-container *ngIf="product.name !== 'SMS' && product.name !== 'WhatsApp'">
                                    <p-checkbox [(ngModel)]="product.isSubscrib" [binary]="true" inputId="binary"
                                        (onChange)="changeSubscrib($event,product)"
                                        [ngModelOptions]="{standalone: true}"></p-checkbox>
                                </ng-container>
                            </td>
                            <td>
                                <span class="pi pi-check" style="color: #7be959;" *ngIf="product.unSubscrib"></span>
                                <span class="pi pi-times" *ngIf="!product.unSubscrib"></span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabPanel>
            <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
                <ng-template pTemplate="header">
                    <span class="btnBars p-mr-0" (click)="editDetails();" *ngIf="index == 0">
                        <i class="pi pi-pencil"></i>
                    </span>
                    <span class="btnBars p-mr-0" (click)="editAddress();" *ngIf="index == 1">
                        <i class="pi pi-pencil"></i>
                    </span>
                    <span class="btnBars p-mr-0" (click)="editSocial();" *ngIf="index == 2">
                        <i class="pi pi-pencil"></i>
                    </span>
                </ng-template>
            </p-tabPanel> -->
        </p-tabView>
    </div>
    <p-footer>
        <button type="button" class="p-button-secondary" pButton (click)="onClose()" label="Cancel"></button>
        <!-- <button type="submit" pButton label="Save"></button> -->
    </p-footer>
</p-dialog>